import { extractVisibleTextFromHtml, HtmlString, hasVisibleHtmlText } from '@breezy/shared'
import DOMPurify from 'dompurify'

export const stripHtml = (html: HtmlString): string => {
  const preProcessed = (html as string)
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/p>/gi, ' ')
    .replace(/<p>/gi, '')
  return DOMPurify.sanitize(preProcessed, { ALLOWED_TAGS: [] })
}

export const extractTextFromHtml = extractVisibleTextFromHtml
export const isHtmlMeaningful = hasVisibleHtmlText

/**
 * Builds a human-friendly preview from HTML/plain text.
 * - Extracts text from HTML.
 * - Optionally collapses whitespace (default: true).
 * - Truncates to maxLength (default: 80) and appends an ellipsis when truncated.
 */
export const getHtmlPreview = (
  html: HtmlString | string,
  options?: { maxLength?: number; collapseWhitespace?: boolean },
): string => {
  const maxLength = options?.maxLength ?? 80
  const collapse = options?.collapseWhitespace ?? true

  let text = extractTextFromHtml(html)
  if (collapse) {
    text = text.replace(/\s+/g, ' ').trim()
  }

  if (text.length <= maxLength) {
    return text
  }

  const truncated = text.slice(0, maxLength).trim()
  return `${truncated}\u2026`
}
